import React, { Component } from 'react';
import PropTypes from 'prop-types';

import assign from 'object-assign';

import ListView from '../Common/ListView.react';
import ListItemUser from './CourseEnrolmentStatsUserListItem.react';
import ListItemCourse from './CourseEnrolmentStatsCourseListItem';

import PersonIcon from 'material-ui/svg-icons/social/person';
import SchoolIcon from 'material-ui/svg-icons/social/school';

import CourseActions from '../../actions/CourseActionCreator';
import CourseEnrolmentStatStore, { sortArrayBy } from '../../stores/CourseEnrolmentStatStore';
import buildContextMenu from '../Common/BuildContextMenu';
import { formatName } from '../../utils/StringUtils';

const getActions = (groupBy) => [
    {
        link: '/dashboard/courses/enrolments/stats/group/user',
        icon: <PersonIcon/>,
        label: 'Progress by User',
        condition: {
            show: groupBy !== 'user'
        }
    },
    {
        link: '/dashboard/courses/enrolments/stats/group/course',
        icon:  <SchoolIcon/>,
        label: 'Progress by Course',
        condition: {
            show: groupBy !== 'course'
        }
    }
];

class CourseEnrolmentStats extends Component {

    constructor({routeParams}, {auth}) {
        super(...arguments);
        this.state = {
            groupBy: routeParams.groupBy,
            sortBy: null,
            stats: [],
            enrolmentStats: [
                {
                    id: '',
                    groupBy: '',
                    name: '',
                    data: [0]
                },
            ],
            sortMap: [],
            actions: buildContextMenu(getActions(routeParams.groupBy), auth)
        };
    }

    getSortOptions() {
        switch (this.props.routeParams.groupBy) {
            case 'user':
                return [
                    {label: 'First name', value: 'firstName'},
                    {label: 'Last name', value: 'lastName'},
                    {label: 'Job role', value: 'jobRole'},
                    {label: 'Visits', value: 'visits'},
                ];
            case 'course':
                return [
                    {label: "Name", value: 'name'},
                    {label: "Code", value: 'code'},
                    {label: "Created", value: 'dateAdded'}
                ];

            default:
                return null;
        }
    }


    getDecorator() {
        switch(this.props.routeParams.groupBy) {

            case 'user':
                return ListItemUser;

            case 'course':
                return ListItemCourse;

            default:
                return ListItemUser;
        }
    }

    componentDidMount() {
        this.onCourseChange = this.onCourseChange.bind(this);
        this.setSortBy = this.setSortBy.bind(this);
        this.statListener = CourseEnrolmentStatStore.addListener(this.onCourseChange);
        CourseActions.getStatsGrouped(this.props.routeParams.groupBy);
    }

    componentWillUnmount() {
        this.statListener.remove();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.routeParams.groupBy !== this.props.routeParams.groupBy) {
            this.setState({
                groupBy: nextProps.routeParams.groupBy,
                stats: [],
                actions: buildContextMenu(getActions(nextProps.routeParams.groupBy), this.context.auth),
            });
            CourseActions.getStatsGrouped(nextProps.routeParams.groupBy);
        }
    }

    render() {

        const itemDecorator = this.getDecorator();
        const sortOptions = this.getSortOptions();

        return (

            <ListView
                title={`Course enrolment progress`}
                items={this.state.stats}
                actions={this.state.actions}
                itemDecorator={itemDecorator}
                sortOptions={sortOptions}
                sortAction={this.setSortBy}
            />

        )
    }

    setSortBy({ sort }) {
        if (sort !== this.state.sortBy) {
            const data = sortArrayBy(sort, this.state.stats);
            this.setState( { sortBy: sort, stats: data });
        }
    }

    onCourseChange() {
        const stats = CourseEnrolmentStatStore.getStats(this.state.groupBy);

        if (stats !== undefined) {
            const enrolmentStats = [];

            if (this.state.groupBy === 'user') {

                stats.forEach(({status, assignments: count, ...stat}) => {
                    if (!count || status === 'cancelled' ) { return; }

                    if  (enrolmentStats[stat.userId] === undefined) {
                        enrolmentStats[stat.userId] = {
                            userId: stat.userId,
                            fullName: formatName(stat),
                            jobRole: stat.jobRole || '',
                            visits: stat.visits || 0,
                            waiting: 0,
                            enrolled: 0,
                            completed: 0,
                            total: 0
                        };
                    }
                    enrolmentStats[stat.userId][status] += count;
                    enrolmentStats[stat.userId].total += count;

                });

            } else if (this.state.groupBy === 'course'){
                stats.forEach(({status, assignments: count, ...stat}) => {
                    if (!count || status === 'cancelled') { return; }

                    let courseId = stat.courseId || stat.id;
                    if (!enrolmentStats[courseId]) {
                        enrolmentStats[courseId] = {
                            courseId: courseId,
                            name: stat.courseName,
                            code: stat.courseCode,
                            dateAdded: stat.dateAdded,
                            courseType: stat.courseType,
                            enrolled: 0,
                            completed: 0,
                            waiting: 0,
                            total: 0,
                        };
                    }
                    if (stat.enrolments) {
                        enrolmentStats[courseId][ status ] += count;
                        enrolmentStats[courseId].total += count;

                    }
                });
            }

            this.setState(assign({}, this.state, { stats: enrolmentStats }));
        }

    }
}

CourseEnrolmentStats.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default CourseEnrolmentStats;
